/* @flow */
import produce from 'immer'
import { ADDITIONAL_URL_DEFAULT_DATA } from './PayPal3.consts'

export default function reducer(state, action: any) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'CHANGE_BLOCK_TITLE':
        draft.blocks[action.value.idx].title = action.value.newBlockTitle
        break
      case 'CHANGE_BLOCK_PARAGRAPH':
        draft.blocks[action.value.idx].paragraph =
          action.value.newBlockParagraph
        break
      case 'ADD_ITEM':
        draft.blocks.push(initialState.blocks[0])
        break
      case 'REMOVE_BLOCK': {
        const { idx } = action.value
        draft.blocks.splice(idx, 1)
        break
      }
      case 'CHANGE_ICON':
        const { idx, iconName } = action.value
        draft.blocks[idx].iconName = iconName
        break
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        break
      case 'CHANGE_TITLE_ALIGNMENT': {
        draft.titleAlignment = action.value
        break
      }
      case 'CHANGE_PARAGRAPH_ALIGNMENT': {
        draft.paragraphAlignment = action.value
        break
      }
      case 'CHANGE_LINK_DATA':
        const { linkData } = action.value
        draft.additionalUrl = linkData.link
        draft.additionalText = linkData.text
        break
      case 'REMOVE_LINK':
        draft.additionalText = ''
        draft.additionalUrl = ''
        break
      case 'ADD_LINK':
        draft.additionalText = ADDITIONAL_URL_DEFAULT_DATA.additionalText
        draft.additionalUrl = ADDITIONAL_URL_DEFAULT_DATA.additionalUrl
        break
      case 'CHANGE_PAYPAL_BUTTON_DATA':
        draft.paypalBtnDefaultProps = action.value.btnData
        break
      case 'REMOVE_BACKGROUND_IMAGE':
        draft.backgroundImgUrl = ''
        draft.backgroundImgDimensions = {}
        break
      case 'CHANGE_BACKGROUND_IMAGE':
        const { url, dimensions } = action.value
        draft.backgroundImgUrl = url
        draft.backgroundImgDimensions = dimensions
        break
      case 'CHANGE_BG_OVERLAY_TRANSPARENCY':
        draft.bgOverlayTransparency = action.value
        break
    }
  })
}
